import styled from 'styled-components';

const FormError = styled.div`
  color: ${({ theme }) => theme.color.error};
`;

export default FormError;
